/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_8_TitleInputs */

const en_gc_search_guides_gridcraft_excel_compatibility_sections_8_title = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_8_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Common Excel compatibility questions`)
};

const zh_gc_search_guides_gridcraft_excel_compatibility_sections_8_title = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_8_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`常见兼容性问题`)
};

/**
* | output |
* | --- |
* | "Common Excel compatibility questions" |
*
* @param {Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_8_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_excel_compatibility_sections_8_title = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_8_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_8_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_excel_compatibility_sections_8_title(inputs)
	return zh_gc_search_guides_gridcraft_excel_compatibility_sections_8_title(inputs)
});
export { gc_search_guides_gridcraft_excel_compatibility_sections_8_title as "gc.search_guides.gridcraft_excel_compatibility.sections.8.title" }